export default {
  namespaced: true,
  state: {
    inputErrors: {
      required: 'Заполните это поле.',
      email: 'Некорректный адрес почты.',
      numeric: 'Значение должно быть числовым.',
      minLength (num) {
        if (num) {
          return `Минимальная длинна ${num} символов`
        }

        return 'Недостаточно символов.'
      },
      phone: 'Не корректный номер телефона.'
    }
  }
}
